// import EditBrokerModal from './modals/EditBrokerModal';
import { SectionHeader, BfiCustomStore } from '../common/SharedComponents';
import store, { searchActions, applicationActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import ReviewersTable from '../applications/appraise/tables/ReviewersTable';
import ReviewerModal from '../applications/appraise/modals/ReviewerModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function AppraisalReviewersSummary() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const gridStore = new BfiCustomStore();

    const _onSearchChange = (event) => {
        dispatch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    reviewer: event.target.value,
                },
            })
        );
    };

    const onAddReviewer = () => {
        dispatch(
            applicationActions.setEditReviewerModal({
                editReviewerModal: { isOpen: true, reviewerId: 0 },
            })
        );
    };

    return (
        <>
            <SectionHeader
                title='Manage Reviewers'
                buttonText='Add New'
                buttonCallback={() => onAddReviewer()}
            />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search to Filter Users'
                        value={searchState.searchText?.reviewer}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div className='scrollable-content'>
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <ReviewersTable gridStore={gridStore} />
                    </div>
                </div>
            </div>
            <ReviewerModal />
        </>
    );
}

export default AppraisalReviewersSummary;
